// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";

export const updateGroupNameHandler = (
    newCreatedGroupName: string,
    groupsNamingRegex: string,
    listGroups?: string[],
    errorMessages = {
        required: "Value Cannot be empty",
        exists: "Group Already exists",
        notValid: siteMessage("Custom_Group_Name_Error_Text") as string,
    },
): { newGroupName: string; error?: string } => {
    let error: string | undefined;
    let newGroupName = newCreatedGroupName;
    const nameRegex = new RegExp(groupsNamingRegex);
    if (!newGroupName) {
        error = errorMessages.required;
    } else if (!nameRegex.test(newGroupName)) {
        error = errorMessages.notValid;
    } else {
        newGroupName = newGroupName.trim().toLowerCase();
        const isAlreadyExists = listGroups?.filter(group => group.trim().toLowerCase() === newGroupName) || [];

        if (isAlreadyExists.length > 0) {
            error = errorMessages.exists;
        }
    }

    return {
        error: translate(error || ""),
        newGroupName,
    };
};
